import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Adminlogin.css";

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loginMessage, setLoginMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoginMessage("");
    setLoading(true);

    setTimeout(() => {
      if (username === "Admin0000" && password === "Admin") {
        setLoading(false);
          // 🔥 STORE ROLE IN SESSIONSTORAGE
          sessionStorage.setItem(
            "userData",
            JSON.stringify({
              role: "admindashboard",
              username: username
            })
          );
        navigate("/admindashboard");
      } else {
        setLoading(false);
        setLoginMessage("Invalid admin credentials.");
      }
    }, 800);
  };

  return (
    <div className="container1">
      {loading && (
        <div className="loading-overlay">
          <div className="spinner" />
          <div className="loading-text">Loading...</div>
        </div>
      )}

      {/* LEFT side */}
      <div className="left-section1">
        <div className="login-card">
          <h1>DATAMILLR</h1>
          {/* <h2>Admin Login</h2> */}
          <form onSubmit={handleSubmit}>
            <label>Admin ID</label>
            <input
              type="id"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter Admin ID"
              required
            />
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter Password"
              required
            />
            <button type="submit" className="primary" disabled={loading}>
              {loading ? "Signing in..." : "Login"}
            </button>
          </form>
          {loginMessage && <p className="login-message1">{loginMessage}</p>}
        </div>
      </div>

      {/* RIGHT side */}
      <div className="right-section1">
        <div className="welcome-text">
          Welcome Back!
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;